import { Divider } from 'src/design/atoms/Divider';
import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import React from 'react';
import { useEnqueueTestJob } from 'src/api/queries/admin/useHealthcheck';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { LinkButton } from 'src/design/atoms/LinkButton';

export const BackgroundJobsPanel: React.FC = () => {
  const enqueueTestJob = useEnqueueTestJob();

  return (
    <Paper>
      <Stack>
        <Title order={4}>Background Jobs</Title>

        <Text>
          Monitor and manage background jobs from the Background Jobs command
          center.
        </Text>

        <Text>
          It reports queue depth, state counts, per-job history and the
          reporting servers, and can requeue, delete or trigger a job.
        </Text>
        <Group>
          <BasicButton
            onClick={() => enqueueTestJob.mutate()}
            loading={enqueueTestJob.isPending}
            size="sm"
            w="fit-content"
          >
            Enqueue Test Job
          </BasicButton>
          <Divider orientation="vertical" />
          <LinkButton
            to="/settings/background-jobs"
            size="sm"
            variant="outline"
          >
            Open Background Jobs
          </LinkButton>
        </Group>
      </Stack>
    </Paper>
  );
};
